/**
 * Tinta y fondos del informe de existencias (del .pen, Stocks / Dirección A).
 * Misma familia que `efficacy/tableStyles.js`; aquí sin cebra: el fondo se
 * reserva para subtotales y TOTAL.
 */
export const INK = '#202223';
export const INK_SOFT = '#5C5F62';
export const INK_FAINT = '#8C9196';
export const LINE = '#E1E3E5';
export const LINE_STRONG = '#C9CCCF';
/** Separador entre grupos de columnas de primer nivel: más que el de subcolumna, menos que el de TOTAL. */
export const LINE_GROUP = '#9CA3AF';
export const HEADER_BG = '#F6F6F7';
export const SUBTOTAL_BG = '#F6F6F7';
export const GRAND_TOTAL_BG = '#EBEDEF';
export const ROW_BG = '#FFFFFF';
export const ROW_HOVER = '#F1F2F4';
export const PRIMARY = '#007A5C';
export const PRIMARY_SOFT = '#E0F8EE';
export const LINK = '#2C6ECB';

/** Paleta pastel de Eficacia para las gráficas. */
export const CHART_INK = '#1F3A5F';
export const PASTEL = ['#a4c2d8', '#d8b4a4', '#a4c8a8', '#C9CCCF', '#d8cfa4', '#b8a4d8', '#a4d8d2', '#d8a4c4'];

/** Tono por temporada (azul invierno, salmón verano, gris básico); intensidad por antigüedad. */
export const SEASON_RAMPS = {
  INVIERNO: ['#5E89AB', '#7FA5C2', '#a4c2d8', '#CCDDE8', '#E2ECF3'],
  VERANO: ['#B07560', '#C4917B', '#d8b4a4', '#E8D2C8', '#F2E4DD'],
  BASICO: ['#8C9196', '#A8ACB0', '#C9CCCF', '#DDDFE1', '#EBEDEF'],
};
